import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-loading-button',
  templateUrl: './loading-button.component.html',
})
export class LoadingButtonComponent {
  @Input() type: 'button' | 'submit' = 'submit';
  @Input() isLoading: boolean;
  @Input() text: string;
  @Input() loadingText: string;
  @Input() isFormInvalid: boolean;
  @Input() buttonSize: string;
  @Input() buttonIcon: string;
  @Input() buttonClass: string;
  @Output() formSubmit = new EventEmitter();

  buttonPrimary = 'btn btn-primary';

  onFormSubmit(): void {
    this.formSubmit.emit();
  }
}
